import * as React from "react";
import gravatar from "gravatar";

interface IProps {
  email: string;
  size: string;
  edit?: boolean;
  className?: string;
}

function Gravatar(props: IProps) {
  return (
    <div className={props.className}>
      <img
        className={"profile-img"}
        src={gravatar.url(props.email, { s: props.size, d: "identicon" })}
      />
      <a
        className={"gravatar-edit"}
        href={"http://en.gravatar.com/profiles/edit/?noclose#about-you"}
        target={"_blank"}
        rel="noopener noreferrer"
      >
        {props.edit && (
          <>
            <i className="fa fa-pencil-square" /> (edit)
          </>
        )}
      </a>
    </div>
  );
}

export default Gravatar;



// WEBPACK FOOTER //
// ./app/javascript/components/core/Gravatar.tsx